import { paths } from '@farmersdog/constants';
import { ResponsiveText } from '@farmersdog/corgi-legacy';
import { Banner, Link } from '@farmersdog/corgi-x';
import { useCoupon, DiscountType } from '@farmersdog/coupons';

import config from '../../config';

import styles from './DiscountBanner.css';
import { getBannerCtaCopy, getCouponBannerCopy } from './utils';

export function DiscountBanner() {
  const { loading, discountAmount, discountType, coupon } = useCoupon({
    apiUrl: `${config.get('app.apiUrl')}/referrer`,
    defaultDiscount: {
      discountAmount: config.get('features.defaultDiscountPercentage'),
      discountType: DiscountType.percentage,
    },
  });

  const bannerCtaCopy = getBannerCtaCopy({ discountAmount });
  const bannerCopy = getCouponBannerCopy({
    discountAmount,
    discountType,
    coupon,
  });

  return (
    <Banner>
      {!loading && (
        <Link href={paths.PATH_SIGNUP}>
          <ResponsiveText
            className={styles.discountBanner}
            variant="body-1"
            color="white"
            as="h5"
          >
            {bannerCopy} <strong className={styles.cta}>{bannerCtaCopy}</strong>
          </ResponsiveText>
        </Link>
      )}
    </Banner>
  );
}
